import { ROUTE_PATH } from "common/constants/sm-constants";
import { FormMetaModel, SmMetaInputModel, SmMetaFileModel } from "common/models/utility-models/meta-model";

export class StudentAssignmentOverviewMetaModel extends FormMetaModel {
    constructor() {
      super('', ROUTE_PATH.studentDetails, ROUTE_PATH.assignment_details, 1);
    }
    override initProperties(): any {
      const formInfo = super.initProperties();
  
      const description = new SmMetaInputModel(
        'description',
        'description',
        'input',
        false,
        'col-6 col-md-6',
        1,
        1,
        'Description ',
        'text',
        '',
        true
      );
  
      const document_path = new SmMetaFileModel(
        'display_filename',
        'display_filename',
        'input',
        false,
        'col-6 col-md-6',
        1,
        1,
        '',
        'text',
        '',
        true
      );
  
      //   const display_filename = new SmMetaFileModel(
      //     'display_filename',
      //     'display_filename',
      //     'file',
      //     false,
      //     'input-fg form-group col-12 col-md-12',
      //     1,
      //     1,
      //     'Display Filename ',
      //     'text',
      //     '',
      //     true,
      // );
  
      return {
        description,
        document_path,
        formInfo,
      };
    }
  }
  